import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader as Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();

  console.log('[ProtectedRoute] 🔒 Render:', {
    loading,
    hasUser: !!user,
    userId: user?.id
  });

  if (loading) {
    console.log('[ProtectedRoute] ⏳ Still loading...');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!user) {
    console.log('[ProtectedRoute] ❌ No user, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  console.log('[ProtectedRoute] ✅ User authenticated, rendering children');
  return <>{children}</>;
}